export const textGeneral = "#3d3b3f";
export const lightGray = "#c0c0c0";
export const bloodyRed = "#E21823";
export const grayHighlight = "#dfdfdf";
export const brightGreen = "#49b632";
export const MAX_NUM_OF_MEMBERS = 10;
export const crossSellingProductsLinkPrefix =
  "https://skischule-serfaus.shopware.styleflasher.dev/detail/";
export const CartURL = "/skischulassistant-configurator/impersonate/";
